import React from "react";
import { ProductCard } from "@/features/product/ProductCard";
import { DrawerPageProps } from "../types";
import {
  GiftProduct,
  giftWithPurchase,
} from "@/helpers/data/cartGiftProductsData";

type ProductSelectorPageProps = DrawerPageProps & {
  onSelect: (product: GiftProduct) => void;
};

export const ProductSelectorPage = ({
  onSelect,
  goToFirstPage,
}: ProductSelectorPageProps) => {
  return (
    <div className="space-y-4 px-5 py-6">
      <h3 className="subtitle mb-4 text-base font-semibold">
        Select Any Gift Below
      </h3>
      {giftWithPurchase.products.map((product) => {
        return (
          <ProductCard
            onClick={() => {
              onSelect(product);
              goToFirstPage();
            }}
            key={product.variantId}
            className="border border-solid border-primary-200"
            productCardValue={product}
            compact={true}
            hoverable={true}
          />
        );
      })}
    </div>
  );
};
